/**
 * Raw ID3 frame.
 *
 * @internal
 *
 * @group ID3
 */
export type RawId3Frame = { type: string; size: number; data: Uint8Array; };
